/* eslint-disable no-return-assign */
/* eslint-disable react/forbid-prop-types */
import React, { useState } from 'react';
import { useMutation } from '@apollo/client';
import { CLOSE_OPPORTUNITY, LIKE_OPPORTUNITY } from '@app/apollo/mutations';
import AlarmOutlinedIcon from '@mui/icons-material/AlarmOutlined';
import RoomIcon from '@mui/icons-material/Room';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { Grid, Box, Zoom, Tooltip } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import FormGroup from '@mui/material/FormGroup';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import Typography from '@atoms/Typography';
import EventIcon from '@mui/icons-material/Event';
import LanguageIcon from '@mui/icons-material/Language';
import PropTypes from 'prop-types';
import moment from 'moment';
import FavoriteIcon from '@mui/icons-material/Favorite';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import AssignmentOutlinedIcon from '@mui/icons-material/AssignmentOutlined';
import { useUser } from '@app/contexts/userContext';

import { OPPORTUNITY_TRACK_ROLE } from '@app/constants/roles';
import Link from '@atoms/Link';
import {
  Statistics,
  CardContent,
  ContentContainer,
  Card,
  CoverImage,
  CoverInfo,
  // InfoContainer,
  useClasses,
  ButtonContainer,
} from './style';
import { useTranslation } from '../../../../config/i18n';

const OpportunityHeader = ({ opportunity, opportunityMemberRole, refetch }) => {
  const { t } = useTranslation(['dashboard', 'common', 'opportunity']);
  const classes = useClasses();
  const { user , isOrganiserOrInvitedAdmin} = useUser();
  const hasAdminAccess = isOrganiserOrInvitedAdmin(opportunity);

  const isXl = useMediaQuery((theme) => theme.breakpoints.up('xl'));
  const isLg = useMediaQuery((theme) => theme.breakpoints.up('lg'));
  const isMd = useMediaQuery((theme) => theme.breakpoints.up('md'));
  const isSm = useMediaQuery((theme) => theme.breakpoints.up('sm'));
  const isXs = useMediaQuery((theme) => theme.breakpoints.up('xs'));

  const userLiked = (oppLikes, userId) => oppLikes?.some((like) => like?.user?.id === userId);

  const [likesCount, setLikesCount] = useState(opportunity?.likes?.length || 0);
  const [isUserLiked, setIsUserLiked] = useState(userLiked(opportunity?.likes, user?.id));

  React.useEffect(() => {
    refetch();
  }, []);

  const [isClosed, setIsClosed] = React.useState(opportunity?.is_closed);

  const [closeOpportunity] = useMutation(CLOSE_OPPORTUNITY, {});

  const hanldeChangeSwitch = () => {
    closeOpportunity({
      variables: {
        id: opportunity.id,
      },
    });
    setIsClosed(!isClosed);
  };

  const handleSuccessLikes = () => {
    refetch();
  };

  const [likesMutation] = useMutation(LIKE_OPPORTUNITY, {
    onCompleted: handleSuccessLikes,
  });

  const handleLike = () => {
    if (isUserLiked) {
      setLikesCount(likesCount - 1);
    } else {
      setLikesCount(likesCount + 1);
    }
    setIsUserLiked(!isUserLiked);
    likesMutation({
      variables: {
        opportunityId: opportunity?.id,
      },
    });
  };

  const getSubstringLength = () => {
    if (isXl) return 100;
    if (isLg) return 65;
    if (isMd) return 45;
    if (isSm) return 30;
    if (isXs) return 20;
    return opportunity.title?.length;
  };

  return (
    <>
      {opportunity && (
        <Card variant="outlined">
          <CoverImage src={opportunity.logo.path} layout="fill" objectFit="cover" loading="eager" />

          <CoverInfo>
            {/* <InfoContainer> */}
            <Grid container spacing={1}>
              <Grid item xs={12}>
                <CardContent>
                  <ContentContainer>
                    {/* {opportunity.title?.length > 60 ? (
                        <Typography variant="h1" gutterBottom>
                          <Tooltip
                            title={opportunity.title}
                            arrow
                            TransitionComponent={Zoom}
                            TransitionProps={{ timeout: 300 }}
                            leaveDelay={500}
                          >
                              {opportunity.title?.substring(0, 61)}...
                          </Tooltip>
                        </Typography>
                      ) : (
                        <Typography variant="h1" gutterBottom>
                          {opportunity.title}
                        </Typography>
                      )} */}

                    {opportunity.title?.length > getSubstringLength() ? (
                      <Typography variant="h1" gutterBottom>
                        <Tooltip
                          title={opportunity.title}
                          arrow
                          TransitionComponent={Zoom}
                          TransitionProps={{ timeout: 300 }}
                          leaveDelay={500}
                        >
                          {opportunity.title?.substring(0, getSubstringLength() + 1)}...
                        </Tooltip>
                      </Typography>
                    ) : (
                      <Typography variant="h1" gutterBottom>
                        {opportunity.title}
                      </Typography>
                    )}
                    <Grid container>
                      <Grid item xs={12} md={6}>
                        {opportunity.organisation && (
                          <Link
                            href="organisation_view"
                            color="secondary"
                            params={{ slug: opportunity.organisation.slug }}
                          >
                            <Typography
                              variant="subtitle1"
                              color="secondary"
                              gutterBottom
                              className={classes.lightGray}
                            >
                              {opportunity.organisation.name}
                            </Typography>
                          </Link>
                        )}
                      </Grid>
                      <Grid item xs={0} md={3} />
                      {opportunity?.external_link && (
                        <Grid item xs={12} md={3}>
                          <a
                            href={opportunity?.external_link}
                            color="secondary"
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ textDecoration: 'none' }}
                            className={classes.lightGray}
                            onMouseEnter={(e) =>
                              (e.currentTarget.style.textDecoration = 'underline')
                            }
                            onMouseLeave={(e) => (e.currentTarget.style.textDecoration = 'none')}
                          >
                            <Box display="flex" alignItems="center">
                              <LanguageIcon />
                              {opportunity.external_link?.length > 30 ? (
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                  gutterBottom
                                  className={classes.lightGray}
                                  sx={{ marginLeft: 1 }}
                                >
                                  <Tooltip
                                    title={opportunity.external_link}
                                    arrow
                                    TransitionComponent={Zoom}
                                    TransitionProps={{ timeout: 300 }}
                                    leaveDelay={500}
                                  >
                                    {opportunity.external_link?.substring(0, 31)}...
                                  </Tooltip>
                                </Typography>
                              ) : (
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                  gutterBottom
                                  className={classes.lightGray}
                                  sx={{ marginLeft: 1 }}
                                >
                                  {opportunity.external_link}
                                </Typography>
                              )}
                            </Box>
                          </a>
                        </Grid>
                      )}
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} md={6}>
                        {opportunity.location && (
                          <Typography variant="h5" component="h1" gutterBottom>
                            <RoomIcon />
                            {opportunity.location.formatted_address}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item xs={0} md={3} />
                      <Grid item xs={12} md={3}>
                        <Tooltip arrow title="Event type">
                          <Box display="flex" alignItems="center">
                            <EventIcon />
                            <Typography variant="h5" component="h1" gutterBottom>
                              {opportunity.is_external ? t('External Event') : t('Internal Event')}
                            </Typography>
                          </Box>
                        </Tooltip>
                      </Grid>
                    </Grid>
                    <Grid container>
                      <Grid item xs={12} md={6}>
                        <Grid container>
                          {opportunity.start_date && (
                            <Grid item xs={12} marginRight="1rem">
                              <span>
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                  gutterBottom
                                  className={classes.lightGray}
                                >
                                  {opportunity.end_date
                                    ? `${moment(opportunity.start_date).format(
                                        'DD MMMM YYYY HH:mm'
                                      )} -
                                      ${moment(opportunity.end_date).format('DD MMMM YYYY HH:mm')}`
                                    : moment(opportunity.start_date).format("DD MMMM 'YYYY HH:mm")}
                                </Typography>
                              </span>
                            </Grid>
                          )}
                          {opportunity.time_zone && (
                            <Grid item xs={12}>
                              <span>
                                <Typography
                                  variant="subtitle1"
                                  color="secondary"
                                  gutterBottom
                                  className={classes.lightGray}
                                >
                                  {opportunity.time_zone}
                                </Typography>
                              </span>
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                      <Grid item xs={0} md={3} />
                      <Grid item xs={12} md={3}>
                        <Box display="flex" alignItems="center" marginRight="1rem" gap="1rem">
                          <Tooltip arrow title="Views">
                            <Box display="flex" alignItems="center">
                              <VisibilityIcon style={{ color: 'secondary', fontSize: '2rem' }} />
                              <Typography variant="body2" color="white">
                                {opportunity?.views?.length}
                              </Typography>
                            </Box>
                          </Tooltip>
                          {user?.id && (
                            <Tooltip arrow title="Likes">
                              <Box display="flex" alignItems="center" onClick={handleLike}>
                                {isUserLiked ? (
                                  <FavoriteIcon style={{ color: 'secondary', fontSize: '2rem' }} />
                                ) : (
                                  <FavoriteBorderIcon
                                    style={{ color: 'secondary', fontSize: '2rem' }}
                                  />
                                )}
                                <Typography variant="body2" color="white">
                                  {likesCount}
                                </Typography>
                              </Box>
                            </Tooltip>
                          )}
                          {
                            hasAdminAccess && (
                              <Tooltip arrow title="Total Applications">
                                <Box display="flex" alignItems="center">
                                  <AssignmentOutlinedIcon style={{ color: 'secondary', fontSize: '2rem' }} />
                                  <Typography variant="body2" color="white">
                                    {opportunity?.submission_applications_count
                                      ? opportunity?.submission_applications_count
                                      : 0}
                                  </Typography>
                                </Box>
                              </Tooltip>
                            )
                          }
                        </Box>
                      </Grid>
                    </Grid>
                    <Statistics>
                      <Grid container spacing={1}>
                        {opportunity.deadline_date && (
                          <Grid item xs={12}>
                            <span className={classes.Allarm}>
                              <AlarmOutlinedIcon />
                              <Typography variant="body2">
                                {t('common:deadline')}{' '}
                                {moment(opportunity.deadline_date).format('DD MMM YYYY')}
                              </Typography>
                            </span>
                          </Grid>
                        )}
                      </Grid>
                    </Statistics>
                  </ContentContainer>
                </CardContent>
              </Grid>
              {!opportunity?.is_external &&
                opportunityMemberRole === OPPORTUNITY_TRACK_ROLE.ORGANIZER && (
                  <ButtonContainer>
                    <FormGroup>
                      <FormControlLabel
                        control={<Switch checked={isClosed} onChange={hanldeChangeSwitch} />}
                        label={isClosed ? 'Event closed' : 'Event opened'}
                        sx={{ marginRight: { sm: '100px' } }}
                      />
                    </FormGroup>
                  </ButtonContainer>
                )}
              {/* (opportunityMemberRole === OPPORTUNITY_TRACK_ROLE.REVIEWER ||
                  opportunityMemberRole === OPPORTUNITY_TRACK_ROLE.MEMBER) && !viewApplication && user && (
                    <ButtonContainer>
                      <ApplyButton
                      // variant="contained"
                      // color="primary"
                      // sx={{ backgroundColor: colors.white, color: colors.primaryColor[700] }}
                      >
                        APPLY
                      </ApplyButton>
                    </ButtonContainer>
                  ) */}
            </Grid>
            {/* </InfoContainer> */}
          </CoverInfo>
        </Card>
      )}
    </>
  );
};

OpportunityHeader.propTypes = {
  opportunity: PropTypes.object,
  opportunityMemberRole: PropTypes.string.isRequired,
  refetch: PropTypes.func,
};

OpportunityHeader.defaultProps = {
  opportunity: undefined,
  refetch: () => {},
};
export default OpportunityHeader;
